import React from 'react';
import { getBedStyle } from './helpers';
import { BedIcon } from './Icons';

const BedCard = ({ bed, isHovered, selectedBeds, onClick, onRightClick, onMouseEnter, onMouseLeave }) => {
  const bedStyle = getBedStyle(bed, isHovered, selectedBeds);

  return (
<div
  style={{
    ...bedStyle,
    width: "65px",
    height: "65px",
    padding: "6px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center", 
    gap: "2px",
  }}
  onClick={onClick}
  onContextMenu={onRightClick}
  onMouseEnter={onMouseEnter}
  onMouseLeave={onMouseLeave}
>
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "24px",
      height: "24px",
    }}
  >
    <BedIcon size={16} />
  </div>

  <div
    style={{
      fontSize: "10px",
      fontWeight: 600,
      letterSpacing: "0.3px",
      textAlign: "center",
    }}
  >
    {bed.id}
  </div>
</div>


  );
};

export default BedCard;
